.container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: spacing(32);
  column-gap: spacing(4);
}

.list {
  display: flex;
  justify-content: center;
  align-items: center;
}

.item {
  @include font(aux, xs);
  font-weight: 700;

  width: spacing(40);
  height: spacing(40);
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: radius(xs);

  &:hover {
    background-color: c(neutral05);
  }

  .page-button {
    height: 100%;
    width: 100%;
    padding: 0;
    margin: 0;
    min-width: 0;
    min-height: 0;
    text-align: center;
    display: block;
    align-content: center;
  }
}

.item.active {
  background-color: c(titanium);

  .page-button {
    color: c(yellow03);
  }
}

.container.dark {
  .item {
    color: c("white");

    &:hover {
      background-color: c(neutral50);
    }

    .page-button {
      color: c("white");
    }
  }

  .item.active {
    background-color: c(neutral60);

    .page-button {
      color: c(yellow03);
    }
  }
}
